// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__z8Nmd","unreadBadge":"styles_unreadBadge__2KvWg","modalContent":"styles_modalContent__3oZ08","modal":"styles_modal__1OlVG"};